<style scoped>
    .opacityBadge > ::v-deep .v-badge > .v-badge__wrapper > .v-badge__badge:hover {
        opacity: 0.3!important;
    }
</style>
<template>
        <span :class="{ opacityBadge: enableClick }">
            <v-badge inline @click.native.prevent="click" :icon="icon" :tile="tile" :color="stateColor" :offset-y="offsetY" :offset-x="offsetX" 
                    :style="{ justifyItems: justifyItems, alignItems: alignItems }">
                <template v-slot:badge>{{ content }}</template>
                <slot>項目名</slot>
            </v-badge>
        </span>
</template>
<script>
    export default {
        props: {
            // 色
            color: {
                type: String,
                default: "grey lighten-1",
                required: false,
            },
            // 縦オフセット
            offsetY: {
                type: String,
            },
            // 横オフセット
            offsetX: {
                type: String,
            },
            // 横方向
            justifyItems: {
                type: String,
                default: "center"
            },
            // 縦方向
            alignItems: {
                type: String,
                default: "center"
            },
            // 内容
            content: {
                type: String,
            },
            // アイコン
            icon : {
                type: String,
            },
            // 四角
            tile: {
                // 親コンポーネントからはtileを指定してするだけでtrueになる
                type: Boolean,
                default: false,
            },
            // クリック可能か
            enableClick: {
                // 親コンポーネントからはenableClickを指定してするだけでtrueになる
                type: Boolean,
                default: false,
            }
        },
        computed: {
            stateColor: {
                get() {
                    if ((this.content == "必　須") || (this.content == "必須")) {
                        return "red";
                    } else {
                        return this.color;
                    }
                },
                set(value) {
                    this.color = value;
                }
            },
        },
        methods: {
            click(e) {
                // 子要素へのクリックイベント伝播を止める
                e.stopPropagation();
                if (this.enableClick) {
                    this.$emit('click');
                }
            }
        }
    }
</script>